export default function Terms({ setPage }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-white px-4 py-16">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm p-8 md:p-12">

        <button
          onClick={() => setPage("landing")}
          className="text-sm text-indigo-600 hover:underline mb-8"
        >
          ← Volver
        </button>

        <h1 className="text-3xl font-bold mb-6">Términos y Condiciones</h1>

        <p className="text-sm text-gray-500 mb-10">
          Última actualización: enero de 2026
        </p>

        <section className="space-y-6 text-gray-700">
          <p>
            Biajando (con B de Barato) es un servicio gratuito de orientación y
            planificación de viajes. Nuestro objetivo es ayudar a los usuarios
            a encontrar opciones de viaje optimizadas según sus preferencias.
          </p>

          <p>
            Biajando no actúa como agencia de viajes ni vende directamente
            vuelos, alojamientos o servicios turísticos. Las reservas y pagos
            se realizan siempre a través de plataformas externas.
          </p>

          <p>
            La información mostrada se basa en los datos proporcionados por el
            usuario y en la disponibilidad de terceros, por lo que puede variar
            en el tiempo.
          </p>

          <p>
            El uso indebido del servicio, así como un uso fraudulento o abusivo,
            podrá conllevar la limitación o suspensión del acceso.
          </p>
        </section>

      </div>
    </div>
  );
}
